


























































































































import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { ExStore } from 'vuex'
import { Route } from 'vue-router'
import store from '@/store'
import dayjs from 'dayjs'
import BaseTab from './baseTab'
import { MedicineDataForCalencer } from '@/store/dispensation/types'

const TODAY = dayjs()

const handleChangeRounting = async (to: Route, next: () => void) => {
  const patientId = Number(to.params.patientId)
  const isoYear = Number(to.query.year || TODAY.year())
  await Promise.all([
    store.dispatch('dispensation/fetch', { patientId, isoYear }),
    store.dispatch('labotest/fetch', { patientId, isoYear })
  ])
  next()
}

@Component
export default class DispensationCalendarTab extends mixins(BaseTab) {
  @Prop(Number) readonly patientId!: number
  @Prop(Number) readonly year!: number | null

  $store!: ExStore

  get yearOptions() {
    const start = 2018
    const end = TODAY.year()
    return [...new Array(end - start + 1)].map((_, i) => end - i)
  }

  get selectedYear() {
    return this.year || TODAY.year()
  }

  set selectedYear(year) {
    this.$router.push({
      name: 'DispensationCalendarTab',
      query: { year: String(year) }
    })
  }

  get sameEffectMedicineGroups() {
    return this.$store.getters['dispensation/sameEffectMedicineGroups']
  }

  get disp() {
    return this.$store.getters['dispensation/dispensationWeeklyGroups']
  }

  get calenderSort() {
    return this.$store.getters['dispensation/calenderSort']
  }

  get labotestWeeklyGroups() {
    return this.$store.getters['labotest/labotestWeeklyGroups']
  }

  get wholeWeeks() {
    const numWeeks = dayjs(`${this.selectedYear}-01-01`).isoWeeksInYear()
    return [...new Array(numWeeks)].map((_, i) => i + 1)
  }

  get wom2woy() {
    let start = dayjs(`${this.selectedYear}-01-01`)
    if (start.isoWeek() === 1) {
      start = start.subtract(start.isoWeekday() - 1, 'day')
    } else {
      start = start.add(1, 'week')
      start = start.subtract(start.isoWeekday() - 1, 'day')
    }
    let month = 0
    return this.wholeWeeks.reduce((group, weekOfYear) => {
      const date = start.add(weekOfYear - 1, 'week')
      const next = date.add(1, 'week').date()
      // 翌週月曜が5〜8日の場合は月が変わっている
      if (date.month() > month || (5 <= next && next <= 8)) {
        if (Math.abs(date.month() - month) <= 1) {
          month += 1
        }
      }

      if (!group[month]) {
        group[month] = []
      }

      group[month].push(weekOfYear)

      return group
    }, [] as Array<Array<number>>)
  }

  getCellClasses(
    medicine: MedicineDataForCalencer | undefined,
    yjCode: string
  ) {
    const classes: string[] = []

    if (!medicine) {
      return classes
    }

    if (this.isNew(medicine)) {
      classes.push('bg_pink')
    } else {
      classes.push('bg_lightblue')
    }

    return classes
  }

  isNew(medicine: MedicineDataForCalencer) {
    return medicine.diffMark === '新規'
  }

  isDuplicatedSameEffectItem(
    medicine: MedicineDataForCalencer,
    yjCode1: string
  ) {
    if (medicine.index > 0) {
      return false
    }

    const key = yjCode1.substr(0, 7)
    const sameEffect = this.sameEffectMedicineGroups[key]
    const { dispensationDate, daysTimes } = medicine
    const startOfTerm = dispensationDate.dayOfYear()
    const endOfTerm = startOfTerm + daysTimes

    return Object.keys(sameEffect).some(yjCode2 => {
      if (yjCode2 === yjCode1) {
        return false
      }

      return sameEffect[yjCode2].some(
        ({ start, end }) =>
          (startOfTerm >= start && startOfTerm <= end) ||
          (endOfTerm >= start && endOfTerm <= end)
      )
    })
  }

  async beforeRouteEnter(to: Route, from: Route, next: () => void) {
    await handleChangeRounting(to, next)
  }

  async beforeRouteUpdate(to: Route, from: Route, next: () => void) {
    await handleChangeRounting(to, next)
  }
}
